module.exports = __webpack_public_path__ + "media/images/games/fifa-21/hiw-2-6f2ffd2936fcc5c27497195b67cdf9d6.jpg";